import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

const testimonialsModules = document.querySelectorAll('.testimonials');

if (testimonialsModules) {
	testimonialsModules.forEach(mod => {
		const testimonialsSwiper = mod.querySelector('.testimonials__swiper');

		if (testimonialsSwiper) {
			const options = {
				centeredSlides: false,
				loop: true,
				shortSwipes: false,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			};

			const swiper = new Swiper(testimonialsSwiper, options);

			const prevArrow = testimonialsSwiper.querySelector('.js-slider-arrow-prev');
			const nextArrow = testimonialsSwiper.querySelector('.js-slider-arrow-next');

			if (prevArrow) {
				prevArrow.addEventListener('click', () => {
					swiper.slidePrev();
				});
			}

			if (nextArrow) {
				nextArrow.addEventListener('click', () => {
					swiper.slideNext();
				});
			}
		}
	});
}
